/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomerServiceInboxPageEntrypointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const customerServiceInboxPageEntrypoint: EntryPoint<
	CustomerServiceInboxPageEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CustomerServiceInboxPageEntrypointComponent>(
		/* webpackChunkName: "async-software-customer-service-inbox-page-entrypoint" */ './CustomerServiceInboxApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
